import * as React from "react";
import {InputFieldState} from "./InputFieldState";
import {TextareaInput} from "./TextareaInput";
import Slider from "react-slick";
import {TextInput} from "./TextInput";
/* Slider zum Wechseln der Seiten */
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slider.css";
import {ButtonBig} from "./ButtonBig";
import {track_google_analytics_event} from "./Analytics";
import {getCookie, setCookie} from "./Cookie";
import {getParam} from "./Request";

interface ContactFormState {
  name: InputFieldState,
  email: InputFieldState,
  body: InputFieldState,
  phone: InputFieldState,
  url: InputFieldState,
  fetchRunning: boolean,
  type: string,
  utm_source: string,
  utm_medium: string,
  utm_campaign: string,
  recipient: InputFieldState,
}

interface ContactFormProps {
  type?: string,
  color?: string,
  recipient: string,
  trn: {
    yourName: string,
    email: string,
    message: string,
    phoneNumber: string,
    requestCallback: string,
    thankForMessage: string,
    weReceivedYourMessage: string,
    submit: string,
  }
}

/**
 * Text Input Element
 */
export class ContactForm extends React.Component<ContactFormProps, ContactFormState> {

  apiHeaders: any;

  constructor(props: any) {
    super(props);

    this.state = {
      name: {value: '', page: 1},
      email: {value: '', page: 1},
      body: {value: '', page: 1},
      phone: {value: '', page: 1},
      url: {value: window.location && window.location.href ? window.location.href : null, page: 1},
      fetchRunning: false,
      type: 'email',
      utm_source: null,
      utm_campaign: null,
      utm_medium: null,
      recipient: {value: this.props.recipient,},
    };

    this.apiHeaders = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
  }

  initCookies() {
    if (getParam('utm_source')) {
      setCookie('utm_source', getParam('utm_source'), 60);
      setCookie('utm_campaign', getParam('utm_campaign'), 60);
      setCookie('utm_medium', getParam('utm_medium'), 60);
    }

    this.setState({
      utm_source: getCookie('utm_source'),
      utm_campaign: getCookie('utm_campaign'),
      utm_medium: getCookie('utm_medium'),
    })

  }

  componentDidMount(): void {
    if (this.props.type == 'callback') {
      this.setState({type: this.props.type});
    }

    // this.initCookies();
  }

  slider: Slider;

  /**
   * Wechselt im Formular auf die gewünschte Seite
   **/
  goToPage(pageNumber: number) {
    this.slider.slickGoTo(pageNumber - 1);
  }

  render() {

    //Slider konfigurieren
    const sliderSettings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToScroll: 0,
      arrows: false,
      draggable: false,
    };

    const classes = 'contact-form contact-form-color-' + this.props.color;
    const trn = this.props.trn;

    return <Slider className={classes} ref={slider => (this.slider = slider)} {...sliderSettings}>
      {this.state.type == 'email' &&
      <div>
          <TextInput state={this.state.name} label={trn.yourName} onChange={(value) => {
            this.setValue('name', value)
          }}/>
          <TextInput state={this.state.email} label={trn.email} onChange={(value) => {
            this.setValue('email', value)
          }}/>
        <TextInput state={this.state.phone} label={trn.phoneNumber} onChange={(value) => {
          this.setValue('phone', value)
        }}/>
          <TextareaInput state={this.state.body} label={trn.message} onChange={(value) => {
            this.setValue('body', value)
          }}/>
          <ButtonBig position="right" onclick={() => this.submit()} label={trn.submit}/>
      </div>
      }

      {this.state.type == 'callback' &&
      <div>
          <TextInput state={this.state.name} label={trn.yourName} onChange={(value) => {
            this.setValue('name', value)
          }}/>
          <TextInput state={this.state.phone} label={trn.phoneNumber} onChange={(value) => {
            this.setValue('phone', value)
          }}/>
          <ButtonBig position="right" onclick={() => this.submit()} label={trn.requestCallback}/>
      </div>
      }

      <div className="message-received">
        <h2>{trn.thankForMessage}</h2>
        <p>{trn.weReceivedYourMessage}</p>
      </div>
    </Slider>

  }

  submit() {

    if (this.state.fetchRunning) {
      return;
    }

    this.setState({fetchRunning: true});

    console.log(this.state);

    fetch('/wp-json/child-theme/v1/contract-form/' + this.state.type, {
      method: 'POST',
      headers: this.apiHeaders,
      body: JSON.stringify(this.state)
    })
      .then(res => res.json())
      .then((data) => {
          Object.keys(data).map(key => {
            this.setState({
              [key]: data[key]
            } as unknown as Pick<ContactFormState, keyof ContactFormState>)
          });

          //Promise auflösen, je nachdem, ob die Seite valide ist
          if (data.success === true) {
            track_google_analytics_event('contact-form', 'submitted', () => {
              this.goToPage(2);
              this.setState({fetchRunning: false});
            });
          } else {
            this.setState({fetchRunning: false});
          }
        }
      ).catch(() => {
        this.setState({fetchRunning: false});
      }
    );
  }

  /**
   * Wert aus Formular in State übernehmen
   */
  setValue(key: string, value: string, isChecked?: boolean) {

    if (value === null) {
      value = '';
    }

    let prevState = this.state as any;
    //Prüft ob es sich um ein InputFieldState Datentyp handelt. Diese Methode setzt nur Werte dieses Types
    if (typeof prevState[key] === 'object' && prevState[key].page) {
      this.setState({
        [key]: {value: value, page: prevState[key].page, isChecked: isChecked}
      } as unknown as Pick<ContactFormState, keyof ContactFormState>)
    }
  }
}